<template>
  <div id="notfound">
    <div class="notfound-bg"></div>
    <div class="notfound">
      <div class="notfound-404">
        <h1>404</h1>
      </div>
      <h2>Oops! Page Not Found</h2>
      <b-button variant="outline-dark" size="lg" :to="{name: 'home'}">Back To Homepage</b-button>
      <!-- <a class="btn btn-lg btn-primary" to="/">Back To Homepage</a> -->
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "../styles/views/_404.scss";
</style>
<script>
export default {
  data() {
    return {};
  }
};
</script>
